import { render, staticRenderFns } from "./xiangqing.vue?vue&type=template&id=83d1fe4a&scoped=true&"
import script from "./xiangqing.vue?vue&type=script&lang=js&"
export * from "./xiangqing.vue?vue&type=script&lang=js&"
import style0 from "./xiangqing.vue?vue&type=style&index=0&id=83d1fe4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d1fe4a",
  null
  
)

export default component.exports